import { NgModule } from '@angular/core';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { ConditionsAcceptorComponent } from './components';

@NgModule({
	declarations: [ConditionsAcceptorComponent],
	exports: [ConditionsAcceptorComponent],
	imports: [SharedCommonModule, SharedComponentsModule]
})
export class UtilsModule {}
